import { FilesUploader } from "components";
import { MediaDirectoryKeys, MediaType } from "constants/enums";
import { t } from "i18next";
import { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormField, MediaFilePicker } from "ui";

import { FeedInsertType } from "../../../../constants";
import { FeedInsertFormValues } from "../FeedInsertForm.types";

import styles from "../FeedInsertForm.module.scss";

const IMAGE_CONFIGS = {
  productsSlider: { width: 390, height: 298, label: "390:298" },
  verticalMediasSlider: { width: 390, height: 298, label: "390:298" },
  horizontalMediasSlider: { width: 390, height: 260, label: "390:260" },
  default: {
    width: 390,
    height: 260,
    label: `390:298 ${t("for vertical medias")}\n390:260 ${t("for horizontal medias")}`
  }
};

const SliderBackgroundImageField = () => {
  const { control, watch } = useFormContext<FeedInsertFormValues>();

  const insertType = watch("type");
  const mediaFields = watch("media");
  const imageConfig = useMemo(
    () =>
      insertType === FeedInsertType.Products
        ? IMAGE_CONFIGS.productsSlider
        : mediaFields[0]?.media
          ? Number(mediaFields[0].media?.height) >
            Number(mediaFields[0].media?.width)
            ? IMAGE_CONFIGS.verticalMediasSlider
            : IMAGE_CONFIGS.horizontalMediasSlider
          : IMAGE_CONFIGS.default,
    [insertType, mediaFields]
  );

  return (
    <Controller
      control={control}
      name="backgroundMedia"
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <FormField
          label={"Slider background image (optional)"}
          errorMessage={error?.message}
        >
          <FilesUploader
            onSuccessUploading={onChange}
            uploadDirectoryKey={MediaDirectoryKeys.ProductSharing}
          >
            {(uploaderProps) => (
              <MediaFilePicker
                {...uploaderProps}
                value={value}
                allowedMediaTypes={[MediaType.IMAGE]}
                customSize={{
                  width: imageConfig.width,
                  height: imageConfig.height
                }}
                label={imageConfig.label}
                mediaClassName={styles.form_sliderBackgroundImage}
                onDeleteMediaFile={() => onChange(null)}
              />
            )}
          </FilesUploader>
        </FormField>
      )}
    />
  );
};

export default SliderBackgroundImageField;
